import { render, staticRenderFns } from "./LiveAiClassroomAcademic.vue?vue&type=template&id=a3133d54&scoped=true&"
import script from "./LiveAiClassroomAcademic.vue?vue&type=script&lang=js&"
export * from "./LiveAiClassroomAcademic.vue?vue&type=script&lang=js&"
import style0 from "./LiveAiClassroomAcademic.vue?vue&type=style&index=0&id=a3133d54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3133d54",
  null
  
)

export default component.exports